<template>
  <div>
    <button @click="togglePopup">Toggle Chart Popup</button>
    <ChartPopup
      :visible="isPopupVisible"
      :startDate="startDate"
      :endDate="endDate"
      @update:visible="handleVisibilityChange"
    />
  </div>
</template>

<script>
import { ref } from 'vue';
import ChartPopup from './ChartPopup.vue'; // Make sure the path to ChartPopup.vue is correct

export default {
  components: {
    ChartPopup,
  },
  setup() {
    const isPopupVisible = ref(false);
    const startDate = ref('2024-01-01');
    const endDate = ref('2024-12-31');

    const togglePopup = () => {
      isPopupVisible.value = !isPopupVisible.value;
    };

    const handleVisibilityChange = (newVisibility) => {
      isPopupVisible.value = newVisibility;
    };

    return {
      isPopupVisible,
      startDate,
      endDate,
      togglePopup,
      handleVisibilityChange,
    };
  },
};
</script>

<style scoped>
/* Add styles if needed */
</style>
